var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 8.94531,
    width: 29,
    height: 34.5556,
    rx: 1.5,
    fill: "#087E38",
    stroke: "#2A2E3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 24,
    height: 31,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3086 17.4512L17.0864 21.229",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0859 17.4512L13.3081 21.229",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8652 19.5508H28.0012",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8867 27.791L14.4608 29.3651",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.084 25.6914L14.4605 29.3643",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8633 27.6855H27.9992",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.248 36.2227L14.6872 37.6618",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0859 34.3027L14.6873 37.6608",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8574 35.9824H27.9933",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6.22222H27.5556C28.1078 6.22222 28.5556 6.66994 28.5556 7.22222V8.77778C28.5556 10.4346 27.2124 11.7778 25.5556 11.7778H16C14.3431 11.7778 13 10.4346 13 8.77778V7.22222C13 6.66994 13.4477 6.22222 14 6.22222H18.5556C18.5556 4.99492 19.5505 4 20.7778 4C22.0051 4 23 4.99492 23 6.22222Z",
    fill: "#087E38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.22222H22.5C22.5 6.49836 22.7239 6.72222 23 6.72222V6.22222ZM18.5556 6.22222V6.72222C18.8317 6.72222 19.0556 6.49836 19.0556 6.22222H18.5556ZM23 6.72222H27.5556V5.72222H23V6.72222ZM27.5556 6.72222C27.8317 6.72222 28.0556 6.94608 28.0556 7.22222H29.0556C29.0556 6.39379 28.384 5.72222 27.5556 5.72222V6.72222ZM28.0556 7.22222V8.77778H29.0556V7.22222H28.0556ZM28.0556 8.77778C28.0556 10.1585 26.9363 11.2778 25.5556 11.2778V12.2778C27.4886 12.2778 29.0556 10.7108 29.0556 8.77778H28.0556ZM25.5556 11.2778H16V12.2778H25.5556V11.2778ZM16 11.2778C14.6193 11.2778 13.5 10.1585 13.5 8.77778H12.5C12.5 10.7108 14.067 12.2778 16 12.2778V11.2778ZM13.5 8.77778V7.22222H12.5V8.77778H13.5ZM13.5 7.22222C13.5 6.94608 13.7239 6.72222 14 6.72222V5.72222C13.1716 5.72222 12.5 6.39379 12.5 7.22222H13.5ZM14 6.72222H18.5556V5.72222H14V6.72222ZM19.0556 6.22222C19.0556 5.27107 19.8266 4.5 20.7778 4.5V3.5C19.2743 3.5 18.0556 4.71878 18.0556 6.22222H19.0556ZM20.7778 4.5C21.7289 4.5 22.5 5.27107 22.5 6.22222H23.5C23.5 4.71878 22.2812 3.5 20.7778 3.5V4.5Z",
    fill: "#2A2E3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1285 11.6492C15.0449 11.3735 15 11.0809 15 10.7778V9.22222C15 8.66994 15.4477 8.22222 16 8.22222H19.5556C20.1078 8.22222 20.5357 7.75261 20.7763 7.25547C21.1359 6.51245 21.897 6 22.7778 6C22.8494 6 22.9201 6.00339 22.99 6.01C22.8832 4.88225 21.9335 4 20.7778 4C19.5505 4 18.5556 4.99492 18.5556 6.22222H14C13.4477 6.22222 13 6.66994 13 7.22222V8.77778C13 10.1315 13.8967 11.2759 15.1285 11.6492Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.22222H22.5C22.5 6.49836 22.7239 6.72222 23 6.72222V6.22222ZM18.5556 6.22222V6.72222C18.8317 6.72222 19.0556 6.49836 19.0556 6.22222H18.5556ZM23 6.72222H27.5556V5.72222H23V6.72222ZM27.5556 6.72222C27.8317 6.72222 28.0556 6.94608 28.0556 7.22222H29.0556C29.0556 6.39379 28.384 5.72222 27.5556 5.72222V6.72222ZM28.0556 7.22222V8.77778H29.0556V7.22222H28.0556ZM28.0556 8.77778C28.0556 10.1585 26.9363 11.2778 25.5556 11.2778V12.2778C27.4886 12.2778 29.0556 10.7108 29.0556 8.77778H28.0556ZM25.5556 11.2778H16V12.2778H25.5556V11.2778ZM16 11.2778C14.6193 11.2778 13.5 10.1585 13.5 8.77778H12.5C12.5 10.7108 14.067 12.2778 16 12.2778V11.2778ZM13.5 8.77778V7.22222H12.5V8.77778H13.5ZM13.5 7.22222C13.5 6.94608 13.7239 6.72222 14 6.72222V5.72222C13.1716 5.72222 12.5 6.39379 12.5 7.22222H13.5ZM14 6.72222H18.5556V5.72222H14V6.72222ZM19.0556 6.22222C19.0556 5.27107 19.8266 4.5 20.7778 4.5V3.5C19.2743 3.5 18.0556 4.71878 18.0556 6.22222H19.0556ZM20.7778 4.5C21.7289 4.5 22.5 5.27107 22.5 6.22222H23.5C23.5 4.71878 22.2812 3.5 20.7778 3.5V4.5Z",
    fill: "#2A2E3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39L38 31V18.5V14C38 12.3431 39.3431 11 41 11C42.6569 11 44 12.3431 44 14V18.5V31L41 39Z",
    fill: "#087E38"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31L41 39L44 31M38 31V18.5M38 31H44M44 31V18.5M38 18.5V14C38 12.3431 39.3431 11 41 11V11C42.6569 11 44 12.3431 44 14V18.5M38 18.5H44",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14V18.5H44V14C44 12.3431 42.6569 11 41 11C39.3431 11 38 12.3431 38 14Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31L41 39L44 31H38Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.dc0ca117a8aabf03a6a94497c3ad8a62.svg";
export { ForwardRef as ReactComponent };